<template>
  <a-modal v-model="visible" :footer="null" class="loginfrm2" :afterClose="close" :destroyOnClose="true" key="loginFrm2" :width="340">
    <div class="title" style="padding-left:28px;background-color:rgb(246,252,255)">
      <span style="font-size:15px;font-weight:bold;">提示</span>
      <p style="font-size:12px;margin-bottom:4px;color:rgb(102,102,102);">尊敬的用户您好!</p>
      <p style="font-size:12px;color:rgb(102,102,102);">检测到您还未关联知展360账号，为保证更好的用户体验，请先完成账号关联</p>
    </div>
    <div class="content">
      <p class="error" v-if="!!loginErr&&countDown>0">{{loginErr}}</p>

      <a-form :autoFormCreate="(form)=>{this.form = form}">
        <a-form-item label="手　机" fieldDecoratorId="mobile" :fieldDecoratorOptions="{rules: [{ required: true, message: '请您输入手机号码' }]}">
          <a-input placeholder='请输入手机号码' size="large" />
        </a-form-item>
        <a-form-item label="密　码" fieldDecoratorId="password" :fieldDecoratorOptions="{rules: [{ required: true, message: '请您输入密码' }]}">
          <a-input placeholder='请输入密码' size="large" type="password" />
        </a-form-item>
        <a-form-item label="验证码" fieldDecoratorId="verifycode" class="captcha" :fieldDecoratorOptions="{rules: [{ required: true, message: '请您输入验证码' }, { validator: this.checkCaptcha, message: '验证码错误' }]}">
          <a-input placeholder='请输入验证码' style="width:150px" size="large" />
          <img :src="`/api/expoApi/Home/Api/verify?key=${mdl.captchaKey}`">
          <a @click="mdl.captchaKey=Date.now()">
            <a-icon type="reload" />刷新</a>
        </a-form-item>
        <a-form-item>
          <a-button @click="loginHandle" type='primary' style="width:100%;" size="large">登录</a-button>
        </a-form-item>
        <a-form-item>
          <div style="display: flex;flex-flow: row;">
            <!-- <a-checkbox style="flex: 1;">下次自动登录 </a-checkbox> -->
            <a target="_blank" :href="`https://www.showguide.cn/expoApi/Home/User/forgetYzb`">忘记密码</a>
            <a-divider type="vertical" style="margin:auto 3px; background:#008cd6;" />
            <a href="/register">免费注册</a>
          </div>
        </a-form-item>
      </a-form>

    </div>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {
      showguide: window.showguide || "http://t.chinashowguide.cn",
      loginErr: "",
      countDown: 0,
      visible: true,
      form: null,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 8 }
      },
      formTailLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 8, offset: 4 }
      },
      mdl: {
        captchaKey: Date.now()
      }
    };
  },
  computed: {
    currentUrl() {
      return encodeURIComponent(location.href);
    }
  },
  created() {
    setInterval(() => {
      !!this.countDown && (this.countDown -= 1);
    }, 1000);
  },
  props: {
    close: Function,
    inviteCode: String,
    success: Function
  },
  methods: {
    loginHandle() {
      this.form.validateFields((err, value) => {
        if (!err) {
          this.$http
            .post(
              "/zzLogin",
              Object.assign({ verifykey: `${this.mdl.captchaKey}`,inviteCode:this.inviteCode,uni: this.$cookies.get("u")}, value)
            )
            .then(res => {
              if (!res.error) {
                this.$cookies.remove("hideRechargeTip", "/");
                this.$cookies.set("access-token", res.data.token, "7d", "/");
                this.success && this.success();
                this.$cookies.set("u", "", 0, "/");
              } else {
                this.loginErr = res.errorMsg || "登陆失败";
                this.$cookies.set("u", "", 0, "/");
                this.countDown = 5;
              }
            })
            .catch(e => console.error(e));
        }
      });
    },
    getQRCode(){
      console.log('qrcode')
    },
    checkCaptcha(rule, value, callback) {
      if (value && value.length == 4) {
        this.$http
          .get("/verifyCode", {
            params: { verifyCode: value, verifyKey: this.mdl.captchaKey }
          })
          .then(res => {
            if (!res.error) {
              callback();
            } else {
              callback(res.errorMsg || Error("验证不通过"));
            }
          })
          .catch(e => {
            callback(e);
          });
      } else {
        callback(1);
      }
    }
  }
};
</script>
<style lang="scss" >
@import "~@/components/layout/style/mixin.scss";
.loginfrm2 {
  label {
    font-size: 13px;
  }
  .captcha {
    img {
      display: inline-block;
      width: 80px;
      height: 40px;
      margin: 0 10px;
    }
    a {
      font-size: 12px;
      i {
        margin-right: 3px;
        &.anticon-reload:before {
          transform: scaleX(-1) rotate(50deg);
        }
      }
    }
  }
  .ant-form-item-label {
    position: absolute;
    z-index: 1;
    margin-left: 10px;
    width: 40px;
  }
  .ant-form-item-required:before {
    display: none;
  }
  button {
    border-radius: 0;
  }
  input {
    border-radius: 0;
    padding-left: 60px;
    vertical-align: middle;
    font-size: 13px;
  }
  .ant-modal-body {
    padding: 0;
  }
  .title {
    width: 100%;
    height: 100px;
    padding: 10px;
    font-size: 15px;
    .logo {
      @include intop-icon;
      background-position: -40px -318px;
      width: 130px;
      height: 40px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .content {
    .error,
    .tip {
      text-align: center;
      color: #ff9600;
      font-size: 12px;
      background-color: #fff7d9;
      height: 25px;
      line-height: 25px;
      border-top: 1px solid #ddf0fb;
    }
    .error {
      color: #f00;
    }
    .ant-form {
      padding: 25px 25px 0 25px;
      
    }
    .wechat_login {
      display: flex;
      height: 28px;
      line-height:28px;
      font-size:12px;
      color:rgb(160,160,160);
      margin-bottom:15px;
      .wechat_login_word {
        padding: 0 6px 0 6px;
      }
      .before_line {
        height:14px;
        width:70px;
        border-bottom:1px solid rgb(230,230,230);
      }
      .after_line {
        margin-left:6px;
        height:14px;
        width:70px;
        border-bottom:1px solid rgb(230,230,230);
      }
    }
  }
}
</style>
